import { render } from "./ModalNavCloseBtn.vue?vue&type=template&id=e5881c44&ts=true"
import script from "./ModalNavCloseBtn.vue?vue&type=script&lang=ts"
export * from "./ModalNavCloseBtn.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__